var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('date-picker',{attrs:{"language":_vm.language,"value":_vm.initDate,"full-month-name":true,"monday-first":true,"input-class":'dp-input',"calendar-class":'dp-calendar'},on:{"selected":_vm.dateSelected}})}
var staticRenderFns = []

export { render, staticRenderFns }